import { componentProvider } from 'js-component-framework';
import Lightbox from './lightbox';
import './lightbox.scss';

const lightboxConfig = {
  name: 'lightbox',
  component: Lightbox,
  querySelector: {
    image: 'img',
    figcaption: 'figcaption',
  },
  querySelectorAll: {},
  options: {},
};

componentProvider(lightboxConfig);
